export const Role = {
    Admin: 'Admin',
    User: 'User',
    Mentor: 'Mentor',
    Representative: 'Representative' 
}